enum MoveResourcesItemType {
    Header = "header",
    Create = "create",
    Project = "project"
}

interface MoveResourcesHeaderItem {
    type: MoveResourcesItemType.Header;
    name: string;
}

interface MoveResourcesCreateItem {
    type: MoveResourcesItemType.Create;
    oid: string;
}

interface MoveResourcesProjectItem {
    type: MoveResourcesItemType.Project;
    pid: string;
    name: string;
    densityScale?: number;
}

type MoveResourcesItem = MoveResourcesHeaderItem | MoveResourcesCreateItem | MoveResourcesProjectItem;

export {
    MoveResourcesItemType,
    MoveResourcesHeaderItem,
    MoveResourcesCreateItem,
    MoveResourcesProjectItem,
    MoveResourcesItem
};
